import { __awaiter } from 'tslib';

const ENDPOINT = 'GETmoods';
function getMoods(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.get(getMoods.endpoint, params, customURL, customHeaders, isKoussa);
    });
}
getMoods.endpoint = ENDPOINT;

export { getMoods as default };
//# sourceMappingURL=getMoods.js.map
